import { HttpClient, HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './core/errors/pagenotfound/pagenotfound.component';
import { MpApiErrorInterceptor } from './core/interceptors/mp-api-error/mp-api-error.interceptor';
import { PipeModule } from './core/pipes/pipe.module';
import { MpLoadingButtonModule } from './widgets/mp-loading-button/mp-loading-button.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateAdapter, MatNativeDateModule } from '@angular/material/core';
import { MPDateAdapter } from './core/adapter/date/mp-date.adapter';
import { MpApiErrorMessageModule } from './widgets/mp-api-error-message/mp-api-error-message.module';
import { authHttpInterceptorFn, provideAuth0 } from '@auth0/auth0-angular';
import { FlexModule } from '@angular/flex-layout';
import { LanguageService } from './core/lang/language.service';
import { LoginErrorComponent } from './core/errors/login-error/login-error.component';
import { TrackerService } from './core/services/tracker.service';

// tslint:disable-next-line:typedef
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// Factory pour APP_INITIALIZER
export function initAppFactory(languageService: LanguageService, trackerService: TrackerService): () => void {
  return () => {
    languageService.initLanguage();
    trackerService.trackLoginSuccess();
  };
}

@NgModule({
  declarations: [AppComponent, PageNotFoundComponent, LoginErrorComponent],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    PipeModule,
    MpApiErrorMessageModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      },
      defaultLanguage: environment.defaultLanguage
    }),
    MpLoadingButtonModule,
    FlexModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initAppFactory,
      deps: [LanguageService, TrackerService],
      multi: true,
    },
    provideAuth0({
      domain: environment.auth0Config.tenantUrl,
      clientId: environment.auth0Config.clientId,
      authorizationParams: {
        scope: environment.auth0Config.scope,
        audience: environment.auth0Config.audience,
        redirect_uri: window.location.origin
      },
      httpInterceptor: {
        allowedList: environment.authorized_urls
      }
    }),
    provideHttpClient(
      withInterceptors([
        authHttpInterceptorFn,
        MpApiErrorInterceptor
      ])
    ),
    { provide: DateAdapter, useClass: MPDateAdapter }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
